import {API_URL} from 'api/constants'

export const V1_URL = `${API_URL}/v1/inventory`



// WEBPACK FOOTER //
// ./app/api/inventory/constants.js